var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.event.showQR)?_c('div',{staticClass:"d-flex flex-column gap-8 align-center"},[_c('div',{staticClass:"event-qr",domProps:{"innerHTML":_vm._s(_vm.event.qr_link)}}),(_vm.canEdit)?_c('app-button',{attrs:{"style-type":_vm.STYLE_TYPE.text},on:{"click":_vm.print}},[_vm._v("Распечатать")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }